import React from "react";

export const GlowOrb = ({ color = "#00d4ff", size = 480, opacity = 0.18, className = "" }) => (
  <div
    aria-hidden
    className={`smk-glow-orb ${className}`}
    style={{
      width: size,
      height: size,
      background: color,
      opacity,
    }}
  />
);

export const GridBg = ({ className = "" }) => (
  <div
    aria-hidden
    className={`absolute inset-0 smk-grid-bg pointer-events-none ${className}`}
    style={{
      maskImage:
        "radial-gradient(ellipse at center, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 70%)",
      WebkitMaskImage:
        "radial-gradient(ellipse at center, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 70%)",
    }}
  />
);

export const Overline = ({ children, className = "" }) => (
  <p className={`smk-overline ${className}`}>{children}</p>
);
